// extracted by mini-css-extract-plugin
export default {"reset-password__body":"MyPagePopup_reset-password__body__0J-U-","-title":"MyPagePopup_-title__3H9AU"};